import { useColorSystem } from "@/utils/functions/color-system";

interface Props {
  onClick: () => void;
}

const SvgClearText: React.FC<Props> = ({ onClick }) => {
  const colors = useColorSystem();
  return (
    <svg
      onClick={(e) => {
        onClick();
        e.stopPropagation();
      }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13834_57799)">
        <path
          d="M13.1621 2.32617C13.0301 2.32929 12.9046 2.38453 12.8132 2.47982L8 7.29297L3.18685 2.47982C3.14024 2.43182 3.08448 2.39367 3.02286 2.36761C2.96125 2.34155 2.89503 2.32813 2.82813 2.32813C2.72862 2.32815 2.63138 2.35786 2.54886 2.41346C2.46633 2.46906 2.40227 2.54801 2.36487 2.64022C2.32746 2.73243 2.31842 2.83371 2.3389 2.93108C2.35938 3.02846 2.40845 3.11751 2.47982 3.18685L7.29297 8L2.47982 12.8132C2.43183 12.8592 2.39352 12.9144 2.36713 12.9755C2.34074 13.0365 2.3268 13.1023 2.32612 13.1688C2.32545 13.2353 2.33805 13.3013 2.36319 13.3629C2.38834 13.4245 2.42552 13.4804 2.47256 13.5274C2.5196 13.5745 2.57555 13.6117 2.63714 13.6368C2.69872 13.662 2.76471 13.6746 2.83123 13.6739C2.89775 13.6732 2.96347 13.6593 3.02453 13.6329C3.08559 13.6065 3.14078 13.5682 3.18685 13.5202L8 8.70703L12.8132 13.5202C12.8592 13.5682 12.9144 13.6065 12.9755 13.6329C13.0365 13.6593 13.1023 13.6732 13.1688 13.6739C13.2353 13.6746 13.3013 13.662 13.3629 13.6368C13.4245 13.6117 13.4804 13.5745 13.5274 13.5274C13.5745 13.4804 13.6117 13.4245 13.6368 13.3629C13.662 13.3013 13.6746 13.2353 13.6739 13.1688C13.6732 13.1023 13.6593 13.0365 13.6329 12.9755C13.6065 12.9144 13.5682 12.8592 13.5202 12.8132L8.70703 8L13.5202 3.18685C13.5929 3.11706 13.6428 3.02694 13.6634 2.92828C13.684 2.82963 13.6743 2.72705 13.6356 2.634C13.5969 2.54095 13.531 2.46177 13.4465 2.40684C13.362 2.35191 13.2629 2.32379 13.1621 2.32617Z"
          fill={colors?.gray3}
        />
      </g>
      <defs>
        <clipPath id="clip0_13834_57799">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>{" "}
    </svg>
  );
};

export default SvgClearText;
